import { render, staticRenderFns } from "./land_pai.vue?vue&type=template&id=7da8d5bb&scoped=true&"
import script from "./land_pai.vue?vue&type=script&lang=js&"
export * from "./land_pai.vue?vue&type=script&lang=js&"
import style0 from "./land_pai.vue?vue&type=style&index=0&id=7da8d5bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da8d5bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7da8d5bb')) {
      api.createRecord('7da8d5bb', component.options)
    } else {
      api.reload('7da8d5bb', component.options)
    }
    module.hot.accept("./land_pai.vue?vue&type=template&id=7da8d5bb&scoped=true&", function () {
      api.rerender('7da8d5bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/create/mem_preview/addon/land/tabs/land_pai.vue"
export default component.exports